import {Injectable} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import {Observable} from 'rxjs';
import {EventService} from '@lv1871/dialog-toolbox';
import {take} from 'rxjs/operators';
import {TrackingService} from '../../../lib-dialog-toolbox/services/tracking.service';
import {UiConfigService} from '@lv1871/core';

@Injectable()
export class PathInterceptor implements HttpInterceptor {
  private _trackingId: string;
  private _visitorId: string;

  constructor(private _eventService: EventService, private _configService: UiConfigService, private _trackingService: TrackingService) {
    this._eventService.sessionId$.pipe(take(1)).subscribe(trackingId => this._trackingId = trackingId);
    this.getVisitorId();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token;
    if (!!sessionStorage.getItem('access_token')) {
      token = sessionStorage.getItem('access_token');
    }
    if (!req.url.startsWith('http') && req.url !== 'assets/config/config.develop.json') {
      req = req.clone({
        url: `${this._configService.settings.public_path}${req.url}`
      });
    } else {
      if (!!token) {
        req = req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token
          }
        });
      }
      if (!!this._trackingId) {
        req = req.clone({
          setHeaders: {
            'Tracking-ID': this._trackingId
          }
        });
      }
      if (!!this._visitorId) {
        req = req.clone({
          setHeaders: {
            'Visitor-ID': this._visitorId
          }
        });
      }
    }
    return next.handle(req);
  }

  async getVisitorId() {
    await this._trackingService.getVisitorId().then(visitorId => this._visitorId = visitorId);
  }

  private getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts?.length === 2) {
      return parts.pop().split(';').shift();
    }
  }


}
